import Footer from "../home/footer"
import Header from "../home/header"
import Productpage from "./productpage"
const store=()=>{
    return(
        <>
            <Header/> 
            <Productpage/>
            <Footer/>
        </>
    )
}
export default store